import "./style.scss";
import batchReportThumbnail from "../../temp_files/schoolPrintable.svg"
import React, {useEffect, useState} from "react";
import {getUploadedFile} from "../../actions/uploads";
import {useDispatch, useSelector} from "react-redux";
import fileDownload from "js-file-download";
import {organizeBatchReports} from "../../utils/reports";

const BatchReports = (props) => {
  const {
    reports,
    schoolStatuses,
    userComposite
  } = props;

  const organizedBatchReports = organizeBatchReports(userComposite, reports, schoolStatuses);

  const dispatch = useDispatch();

  const [fileDownloadName, setFileDownloadName] = useState('');

  const downloadedFile = useSelector((store) => store.uploads.downloadedFile);

  const downloadBatchReport = async (report) => {
    const fileName = report.s3path
    await dispatch(getUploadedFile(report.atpCode, fileName));
    await setFileDownloadName(fileName);
  }

  useEffect(() =>  {
      if (downloadedFile && fileDownloadName) {
        setFileDownloadName('');
        fileDownload(downloadedFile, fileDownloadName);
      }
    }, [dispatch, downloadedFile, fileDownloadName]
  );

  const schoolList = (school, schoolIndex) => {
    return (<>
      <h3 key={`batch-school-${schoolIndex}`} className='batch-report-school'>{school.schoolName}</h3>
      {Object.values(school.gradeLevels).map((gradeLevel, gradeLevelIndex) => {
        return gradeLevelList(gradeLevel, gradeLevelIndex, schoolIndex);
      })}
      </>)
  }

  const gradeLevelList = (gradeLevel, gradeLevelIndex, schoolIndex) => {
    return (<>
      <h4 key={`batch-gradelevel-${schoolIndex}-${gradeLevelIndex}`} className='batch-report-grade-level'>
        Grade Level: {gradeLevel.gradeLevel}
      </h4>
      <ul>
        {gradeLevel.reports.map((report, index) => {
          return (
            <li key={report.id} className='batch-report-item'>
              <a href="#" className="batch-reports-link" title="Opens in a new tab" onClick={(e) => {
                e.preventDefault();
                downloadBatchReport(report);
              }
              }>
                <img alt="" src={batchReportThumbnail}
                     className='batch-report-thumbnail' />
                <span className='report-title'>
                  {report.title}
                </span>
              </a>
            </li>
          )
        })}
      </ul>
    </>);
  }

  const reportsList =
    <div className="batch-report-list">
      {
        Object.values(organizedBatchReports).map((school, index) => {
          return schoolList(school, index);
        })
      }
    </div>

  const noReports =
    <div className='no-batch-reports'>
      There are no batch reports available to download at this time.
    </div>

  return  (
    <div className='batch-report-container'>
      <section className="reports-section" aria-labelledby={`report-batch`}>
        <h2 id={`report-batch`}>Student Report Batches</h2>
        {(reports.length > 0 && Object.values(organizedBatchReports).length > 0) ? reportsList : noReports}
      </section>
    </div>
  )
}

export default BatchReports;